import { render, staticRenderFns } from "./CampaignQuestions.vue?vue&type=template&id=fbd15d30&scoped=true"
import script from "./CampaignQuestions.vue?vue&type=script&lang=js"
export * from "./CampaignQuestions.vue?vue&type=script&lang=js"
import style0 from "./CampaignQuestions.vue?vue&type=style&index=0&id=fbd15d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd15d30",
  null
  
)

export default component.exports